export default "__VITE_ASSET__DcW6bGE7__"